import React from "react";
import {
    MDBModal,
    MDBModalHeader,
    MDBModalBody,
    MDBModalFooter,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBContainer,
    MDBSelect,
    MDBSpinner
} from "mdbreact";
import firebase from "../../../firebase"
import { toast } from 'react-toastify';
import {Select} from "antd";
import axios from 'axios';
import buyerOrgList from "./BuyerOrgList";
class CreateNewBuyerOrg extends React.Component {
    constructor(props) {
        const dt = new Date();
        super(props);
        this.tagBoxRef = null;
        this.state = {
            loading: false,
            fax: '',
            tel: '',
            companyFax: '',
            companyTel: '',
            companyCorpNo: '',
            address: '',
            companyAddress: '',
            closingDate: '',
            closingDateList: [{value: 10 , label: '10日'}, {value: 15 , label: '15日'}, {value: 20 , label: '20日'}, {value: 25 , label: '25日'}, {value: 31 , label: '月末'}],
            company: '',
            companyName: '',
            companyKanaName: '',
            kana: '',
            name: '',
            seller: '',
            sellerName : '',
            users: [],
            zipcode: '',
            companyZip: '',
            companyList: [],
            sellerList: [],
            buyerList: [],
            makerList: [],
            selectedBuyerOrg: null,
            selectedSellerOrg: null,
            paymentMethod: '',
            paymentCheckList: [ {value: '当月',label:'当月'}, {value: '翌月',label: '翌月'}],
            paymentCheck: '',
            paymentDate: '',
            isSelectedCompany: false,
            isNewCompany: false,
            errModal: false,
            regModal: false,
            days:   Array.from(Array(31), (v, index) => {return {value: index + 1,label: index + 1} }),
            //userType: '',
            orgData: {},
            mode: 'buyer',
            modeList: [ {value: 'buyer',label:'購入U'}, {value: 'seller',label: '販社U'}, {value: 'maker',label: 'メーカーU'}],
        }
    }
    componentDidMount() {
        this.setCompanyList();
        this.setSellerList();
        this.setBuyerList();
        this.setMakerList();
        this.props.mode === 'edit' && this.setOrgData();
    }
    setOrgData = async () => {
        if (this.state.loading) {
            return;
        }
        this.setState({loading: true});
        let organizationRef =  this.props.db.collection('organizations').doc(this.props.id);
        let getDoc = organizationRef.get()
            .then(doc => {
                if (!doc.exists) {
                    console.log('No such organization document!')
                } else {
                    if ( doc.data().active ) {
                        let data = {};
                        data = doc.data();
                        data.id = doc.id;
                        console.log('data', data);
                        this.setState({
                            fax: data['FAX'],
                            tel: data['TEL'],
                            address: data.address,
                            company: data.company,
                            closingDate: data.closingDate,
                            companyName: data.companyName,
                            kana: data.kana,
                            name: data.name,
                            zipcode: data.zipcode,
                            paymentMethod: data.paymentMethod || '',
                            paymentCheck: data.paymentCheck || '',
                            paymentDate: data.paymentDate || '',
                            isSelectedCompany: true,
                            seller: data.seller || '',
                            sellerName: data.seller || '',
                            mode: data.buyer ? 'buyer' : (data.reseller ? 'seller' : 'maker'),
                            orgData: data,
                        })
                        if(data.buyers && data.buyers.length > 0 ){
                            let buyerList = data.buyers.map((data) => {
                                return data.organization
                            });
                            this.setState({selectedBuyerOrg: buyerList})
                        }
                        if(data.sellers && data.sellers.length > 0 ){
                            let sellerList = data.sellers.map((data) => {
                                return data.organization
                            });
                            this.setState({selectedSellerOrg: sellerList})
                        }
                        this.setState({loading: false})
                        // data && data.users && this.setupUsersData(data.users);
                        // this.setupCompanyData(data.company);

                    }
                }
            })
            .catch(err => {
                console.log('Error getting organization document', err)
            })
    }
    setCompanyList = async () => {
        if (this.state.loading) {
            return;
        }
        this.setState({loading: true});
        let company = await this.props.db.collection('company').where('active', '==', true).get();
        const companyData = company.docs.map(doc => ({...doc.data(), id: doc.id}));
        this.setState({companyList: companyData,loading: false});
    }
    setSellerList = async () => {
        if (this.state.loading) {
            return;
        }
        this.setState({loading: true});
        let seller = await this.props.db.collection('organizations').where('reseller', '==', true).where('active', '==', true).get();
        const sellerData = seller.docs.map(doc => ({...doc.data(), id: doc.id}));
        this.setState({sellerList: sellerData,loading: false});
    }
    setMakerList = async () => {
        if (this.state.loading) {
            return;
        }
        this.setState({loading: true});
        let seller = await this.props.db.collection('organizations').where('maker', '==', true).where('active', '==', true).get();
        const sellerData = seller.docs.map(doc => ({...doc.data(), id: doc.id}));
        this.setState({makerList: sellerData,loading: false});

    }
    setBuyerList = async () => {
        if (this.state.loading) {
            return;
        }
        this.setState({loading: true});
        let buyer = await this.props.db.collection('organizations').where('buyer', '==', true).where('active', '==', true).get();
        const buyerData = buyer.docs.map(doc => ({...doc.data(), id: doc.id}));

        let buyerList = buyerData.map((data) => {
            return {value: data.id, label: data.company_name + ' ' +data.name}
        });

        this.setState({buyerList: buyerList,loading: false});
    }
    handleZipChange = async (e) => {
        const inputZip = this.state.companyZip;
        if (inputZip.length === 8) {
            try {
                const response = await axios.get(`https://api.zippopotam.us/JP/${inputZip}`);
                const data = response.data;
                const place = data.places[0];
                this.setState({companyAddress: `${place['place name']} ${place['state']}`})

            }
            catch (error) {console.error('ZIP code not found',error); }

        }

    }
    onSubmit = () => {
        let company = this.state.companyList.filter(v => v.id === this.state.company)[0];
        let buyers = [];
        let sellers = [];
       ['seller','maker'].includes(this.state.mode) && this.state.selectedBuyerOrg.map(e => {
            let b = {};
            let c = this.state.mode === 'seller' ? this.state.buyerList.filter(v => v.value === e)[0] : this.state.sellerList.filter(v => v.id === e)[0];
            b.name = this.state.mode === 'seller' ? c.label : c.company_name + ' ' + c.name;
            b.organization = e;
            buyers.push(b);

        })
        this.state.mode === 'seller' && this.state.selectedSellerOrg.map(e => {
            let b = {};
            let c = this.state.makerList.filter(v => v.id === e)[0] ;
            b.carriage = c.carriage === undefined ? 0 : c.carriage;
            b.carriage_free = c.carriage_free === undefined ? 0 : c.carriage_free;
            b.name = c.company_name + ' ' + c.name;
            b.organization = e;
            sellers.push(b);

        })
        if(this.props.mode === 'new') {
            let orgRef = this.props.db.collection('organizations').doc();
            let seller = this.state.sellerList.filter(v => v.id === this.state.seller)[0];
            let anyData ={};
            if(this.state.closingDate !== undefined || this.state.closingDate !== ''){
                anyData.closingDate = this.state.closingDate;
            }
            if(this.state.paymentMethod !== undefined || this.state.paymentMethod !== ''){
                anyData.paymentMethod = this.state.paymentMethod;
            }
            if(this.state.paymentCheck !== undefined || this.state.paymentCheck !== ''){
                anyData.paymentCheck = this.state.paymentCheck;
            }
            if(this.state.paymentDate !== undefined || this.state.paymentDate !== ''){
                anyData.paymentDate = this.state.paymentDate;
            }
            if(this.state.isSelectedCompany) {
                if(this.state.mode === 'buyer') {
                    orgRef.set({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        active: true,
                        address: this.state.address,
                        buyer: true,
                        closingDate: this.state.closingDate,
                        company: this.state.company,
                        company_name: company['name'],
                        kana: this.state.kana,
                        name:this.state.name,
                        seller:this.state.seller,
                        seller_name: seller['company_name'] + ' ' + seller['name'],
                        zipcode: this.state.zipcode,
                        created: firebase.firestore.Timestamp.fromDate(new Date()),
                        carriage: 0,
                        carriage_free: 0,...anyData
                    }, { merge: true });
                }
                else if(this.state.mode === 'seller') {
                    orgRef.set({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        active: true,
                        address: this.state.address,
                        reseller: true,
                        closingDate: this.state.closingDate,
                        company: this.state.company,
                        company_name: company['name'],
                        kana: this.state.kana,
                        name:this.state.name,
                        buyers: buyers,
                        sellers: sellers,
                        zipcode: this.state.zipcode,
                        created: firebase.firestore.Timestamp.fromDate(new Date()),
                        carriage: 0,
                        carriage_free: 0,...anyData
                    }, { merge: true });
                }
                else if(this.state.mode === 'maker') {
                    orgRef.set({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        active: true,
                        address: this.state.address,
                        maker: true,
                        closingDate: this.state.closingDate,
                        company: this.state.company,
                        company_name: company['name'],
                        kana: this.state.kana,
                        name:this.state.name,
                        buyers: buyers,
                        zipcode: this.state.zipcode,
                        created: firebase.firestore.Timestamp.fromDate(new Date()),
                        carriage: 0,
                        carriage_free: 0,...anyData
                    }, { merge: true });
                }
                console.log('orgRef',orgRef.id)
            }
            else if(this.state.isNewCompany) {
                let companyRef = this.props.db.collection('company').doc();
                companyRef.set({
                    FAX: this.state.companyFax,
                    TEL: this.state.companyTel,
                    active: true,
                    address: this.state.companyAddress,
                    kana: this.state.companyKanaName,
                    name:this.state.companyName,
                    zipcode: this.state.companyZip,
                    '法人番号': this.state.companyCorpNo,
                    created: firebase.firestore.Timestamp.fromDate(new Date()),
                }, { merge: true });
                console.log('companyRef',companyRef.id)

                if(this.state.mode === 'buyer') {
                    orgRef.set({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        active: true,
                        address: this.state.address,
                        buyer: true,
                        closingDate: this.state.closingDate,
                        company: companyRef.id,
                        company_name: this.state.companyName,
                        kana: this.state.kana,
                        name:this.state.name,
                        seller:this.state.seller,
                        seller_name: seller['company_name'] + ' ' + seller['name'],
                        zipcode: this.state.zipcode,
                        created: firebase.firestore.Timestamp.fromDate(new Date()),
                        carriage: 0,
                        carriage_free: 0,...anyData
                    }, { merge: true });
                }
                else if(this.state.mode === 'seller') {
                    orgRef.set({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        active: true,
                        address: this.state.address,
                        reseller: true,
                        closingDate: this.state.closingDate,
                        company: companyRef.id,
                        company_name: this.state.companyName,
                        kana: this.state.kana,
                        name:this.state.name,
                        buyers: buyers,
                        sellers: sellers,
                        zipcode: this.state.zipcode,
                        created: firebase.firestore.Timestamp.fromDate(new Date()),
                        carriage: 0,
                        carriage_free: 0,...anyData
                    }, { merge: true });
                }
                else if(this.state.mode === 'maker') {
                    orgRef.set({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        active: true,
                        address: this.state.address,
                        maker: true,
                        closingDate: this.state.closingDate,
                        company: companyRef.id,
                        company_name: this.state.companyName,
                        kana: this.state.kana,
                        name:this.state.name,
                        buyers: buyers,
                        zipcode: this.state.zipcode,
                        created: firebase.firestore.Timestamp.fromDate(new Date()),
                        carriage: 0,
                        carriage_free: 0,...anyData
                    }, { merge: true });
                }

                console.log('orgReforgRef',orgRef.id)
                //this.props.cProps.history.push('/buyerOrgList');
            }
            this.props.cProps.history.push('/orgList');
        }
        else {
            if(this.state.isSelectedCompany) {
                if(this.state.mode === 'buyer') {
                    let seller = this.state.sellerList.filter(v => v.id === this.state.seller)[0];
                    let orgRef = this.props.db.collection('organizations').doc(this.props.id).update({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        address: this.state.address,
                        closingDate: this.state.closingDate || '',
                        company: this.state.company,
                        company_name: company['name'],
                        kana: this.state.kana,
                        name:this.state.name,
                        seller:this.state.seller,
                        seller_name: seller['company_name'] + ' ' + seller['name'],
                        zipcode: this.state.zipcode,
                        paymentMethod: this.state.paymentMethod || '',
                        paymentCheck: this.state.paymentCheck || '',
                        paymentDate: this.state.paymentDate || '',
                    });
                    console.log('orgBuyerEdit')
                }
                else if(this.state.mode === 'seller') {
                    let orgRef = this.props.db.collection('organizations').doc(this.props.id).update({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        address: this.state.address,
                        closingDate: this.state.closingDate || '',
                        company: this.state.company,
                        company_name: company['name'],
                        kana: this.state.kana,
                        name:this.state.name,
                        buyers: buyers,
                        sellers: sellers,
                        zipcode: this.state.zipcode,
                        paymentMethod: this.state.paymentMethod || '',
                        paymentCheck: this.state.paymentCheck || '',
                        paymentDate: this.state.paymentDate || '',
                    });
                }
                else if(this.state.mode === 'maker') {
                    let orgRef = this.props.db.collection('organizations').doc(this.props.id).update({
                    FAX: this.state.fax,
                    TEL: this.state.tel,
                    address: this.state.address,
                    closingDate: this.state.closingDate || '',
                    company: this.state.company,
                    company_name: company['name'],
                    kana: this.state.kana,
                    name:this.state.name,
                    buyers: buyers,
                    zipcode: this.state.zipcode,
                    paymentMethod: this.state.paymentMethod || '',
                    paymentCheck: this.state.paymentCheck || '',
                    paymentDate: this.state.paymentDate || '',
                });
                }
            }
            else if(this.state.isNewCompany) {
                let companyRef = this.props.db.collection('company').doc();
                companyRef.set({
                    FAX: this.state.companyFax,
                    TEL: this.state.companyTel,
                    active: true,
                    address: this.state.companyAddress,
                    kana: this.state.companyKanaName,
                    name:this.state.companyName,
                    zipcode: this.state.companyZip,
                    '法人番号': this.state.companyCorpNo,
                    created: firebase.firestore.Timestamp.fromDate(new Date()),
                }, { merge: true });
                if(this.state.mode === 'buyer') {
                    let seller = this.state.sellerList.filter(v => v.id === this.state.seller)[0];
                    let orgRef = this.props.db.collection('organizations').doc(this.props.id).update({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        address: this.state.address,
                        closingDate: this.state.closingDate || '',
                        company: companyRef.id,
                        company_name: this.state.companyName,
                        kana: this.state.kana,
                        name:this.state.name,
                        seller:this.state.seller,
                        seller_name: seller['company_name'] + ' ' + seller['name'],
                        zipcode: this.state.zipcode,
                        paymentMethod: this.state.paymentMethod || '',
                        paymentCheck: this.state.paymentCheck || '',
                        paymentDate: this.state.paymentDate || '',
                    });
                }
                else if(this.state.mode === 'seller') {
                    let orgRef = this.props.db.collection('organizations').doc(this.props.id).update({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        address: this.state.address,
                        closingDate: this.state.closingDate || '',
                        company: companyRef.id,
                        company_name: this.state.companyName,
                        kana: this.state.kana,
                        name:this.state.name,
                        buyers: buyers,
                        sellers: sellers,
                        zipcode: this.state.zipcode,
                        paymentMethod: this.state.paymentMethod || '',
                        paymentCheck: this.state.paymentCheck || '',
                        paymentDate: this.state.paymentDate || '',
                    });
                }
                else if(this.state.mode === 'maker') {
                    let orgRef = this.props.db.collection('organizations').doc(this.props.id).update({
                        FAX: this.state.fax,
                        TEL: this.state.tel,
                        address: this.state.address,
                        closingDate: this.state.closingDate || '',
                        company: companyRef.id,
                        company_name: this.state.companyName,
                        kana: this.state.kana,
                        name:this.state.name,
                        buyers: buyers,
                        zipcode: this.state.zipcode,
                        paymentMethod: this.state.paymentMethod || '',
                        paymentCheck: this.state.paymentCheck || '',
                        paymentDate: this.state.paymentDate || '',
                    });
                }
            }
            this.props.cProps.history.push('/orgList');
        }
    }
    render() {
        let isDisabled = true;
        if(this.state.isSelectedCompany && this.state.mode === 'buyer' && this.state.company !== '' && this.state.fax !== '' && this.state.tel !== '' && this.state.address !== '' && this.state.kana !== ''
            && this.state.name !== ''  && this.state.seller && this.state.zipcode !== '') {
            isDisabled = false;
        }
        else if(this.state.isNewCompany && this.state.mode === 'buyer' && this.state.companyFax !== '' && this.state.companyTel !== '' && this.state.companyCorpNo !== '' && this.state.companyAddress !== '' && this.state.companyName !== ''
            && this.state.companyKanaName !== '' && this.state.companyZip !== '' && this.state.fax !== '' && this.state.tel !== '' && this.state.address !== '' && this.state.kana !== ''
            && this.state.name !== '' && this.state.seller !== '' && this.state.zipcode !== '') {
            isDisabled = false;
        }
        else if(this.state.isSelectedCompany && this.state.mode === 'seller' && this.state.company !== '' && this.state.fax !== '' && this.state.tel !== '' && this.state.address !== '' && this.state.kana !== ''
            && this.state.name !== ''  && this.state.selectedBuyerOrg && this.state.selectedSellerOrg && this.state.zipcode !== '') {
            isDisabled = false;
        }
        else if(this.state.isNewCompany && this.state.mode === 'seller' && this.state.companyFax !== '' && this.state.companyTel !== '' && this.state.companyCorpNo !== '' && this.state.companyAddress !== '' && this.state.companyName !== ''
            && this.state.companyKanaName !== '' && this.state.companyZip !== '' && this.state.fax !== '' && this.state.tel !== '' && this.state.address !== '' && this.state.kana !== ''
            && this.state.name !== '' && this.state.selectedBuyerOrg && this.state.selectedSellerOrg && this.state.zipcode !== '' ) {
            isDisabled = false;
        }
        else if(this.state.isSelectedCompany && this.state.mode === 'maker' && this.state.company !== '' && this.state.fax !== '' && this.state.tel !== '' && this.state.address !== '' && this.state.kana !== ''
            && this.state.name !== ''  && this.state.selectedBuyerOrg && this.state.zipcode !== '') {
            isDisabled = false;
        }
        else if(this.state.isNewCompany && this.state.mode === 'maker' && this.state.companyFax !== '' && this.state.companyTel !== '' && this.state.companyCorpNo !== '' && this.state.companyAddress !== '' && this.state.companyName !== ''
            && this.state.companyKanaName !== '' && this.state.companyZip !== '' && this.state.fax !== '' && this.state.tel !== '' && this.state.address !== '' && this.state.kana !== ''
            && this.state.name !== '' && this.state.selectedBuyerOrg && this.state.zipcode !== '') {
            isDisabled = false;
        }
        // else if(this.state.isSelectedCompany && this.props.mode === 'edit' && this.state.company !== '' && this.state.company !== this.state.orgData.company && this.state.fax !== '' && this.state.fax !== this.state.orgData['FAX'] && this.state.tel !== '' && this.state.tel !== this.state.orgData['TEL'] && this.state.address !== ''
        //     && this.state.address !== this.state.orgData['address'] && this.state.closingDate && this.state.closingDate !== this.state.orgData['closingDate'] && this.state.kana !== '' && this.state.kana !== this.state.orgData['kana']
        //     && this.state.name !== '' && this.state.name !== this.state.orgData['name'] && this.state.seller !== '' && this.state.seller !== this.state.orgData['seller'] && this.state.zipcode !== '' && this.state.zipcode !== this.state.orgData['zipcode'] && this.state.paymentMethod !== ''
        //     && this.state.paymentMethod !== this.state.orgData['paymentMethod'] && this.state.paymentCheck !== '' && this.state.paymentCheck !== this.state.orgData['paymentCheck'] && this.state.paymentDate !== '' && this.state.paymentDate !== this.state.orgData['paymentDate'] ) {
        //     isDisabled = false;
        // }
        console.log('this.state.closingDate', this.state.closingDate);
        return (
            <>
                {
                    this.props.user && this.props.user.admin &&
                    <MDBContainer>
                        {this.state.loading && <div className="d-flex justify-content-center mt-5"><MDBSpinner/></div>}
                        <MDBRow>
                            <MDBCol md="12" className="mb-3">
                                <h2>{this.props.mode === 'new' ? '新規事業所登録' : '事業所編集'}</h2>
                                <div style={{
                                    height: 30, justifyContent: 'flex-start', padding: 5,
                                    alignItems: "center", backgroundColor: '#2E75B6', color: 'white'
                                }}>企業情報
                                </div>
                                <form>
                                    <div style={{
                                        // display: 'flex',
                                        // flexDirection: 'column',
                                        // alignItems: 'flex-start',
                                        border: '1px solid #B9B9B9',
                                        padding: 10,
                                        marginBottom: 20,
                                        marginTop: 10
                                    }}>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="isSelectedCompany"
                                                id="isSelectedCompany"
                                                value="最短"
                                                onChange={() => {
                                                    this.setState({isSelectedCompany: true, isNewCompany: false});
                                                }}
                                                checked={this.state.isSelectedCompany}

                                            />
                                            <label className="form-check-label" htmlFor="isSelectedCompany">
                                                登録済みの企業から選択する
                                            </label>
                                        </div>
                                        <br/>
                                        <div className="form-check">
                                            <Select
                                                showSearch
                                                value={this.state.company}
                                                disabled={this.state.isSelectedCompany ? false : true}
                                                optionFilterProp="label"
                                                filterSort={(optionA, optionB) =>
                                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                }
                                                style={{ width: '100%' }}
                                                placeholder="選択してください"
                                                //defaultValue={this.state.company}
                                                onChange={(e) => {
                                                    this.setState({company: e})}}
                                                options={this.state.companyList.map((data) => ( {value: data.id, label: data.name}))}
                                            />
                                        </div>
                                    </div>
                                    <div style={{
                                        // display: 'flex',
                                        // flexDirection: 'column',
                                        // alignItems: 'flex-start',
                                        border: '1px solid #B9B9B9',
                                        padding: 10,
                                        marginBottom: 20,
                                        marginTop: 10
                                    }}>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="isNewCompany"
                                                id="isNewCompany"
                                                value="最短"
                                                onChange={() => {
                                                    this.setState({isSelectedCompany: false, isNewCompany: true});
                                                }}
                                                checked={this.state.isNewCompany}

                                            />
                                            <label className="form-check-label" htmlFor="isNewCompany">
                                                新しい企業を登録
                                            </label>
                                        </div>
                                    </div>
                                    {
                                        this.state.isNewCompany &&
                                        <div style={{
                                            border: '1px solid #B9B9B9',
                                            padding: 10,
                                            marginBottom: 20,
                                            marginTop: 10
                                        }}>
                                            <div className="form-check">
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <label htmlFor="companyName" className="grey-text">
                                                        会社名
                                                    </label>
                                                    &nbsp;
                                                    <span className={'cart-require'}
                                                          style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    id="companyName"
                                                    className="form-control"
                                                    name="companyName"
                                                    onChange={(e) => {
                                                        this.setState({
                                                            companyName: e.currentTarget.value
                                                        });
                                                    }}
                                                    value={this.state.companyName}
                                                />
                                                <br/>
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <label htmlFor="companyKanaName" className="grey-text">
                                                        会社名かな
                                                    </label>
                                                    &nbsp;
                                                    <span className={'cart-require'}
                                                          style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    id="companyKanaName"
                                                    className="form-control"
                                                    name="companyKanaName"
                                                    onChange={(e) => {
                                                        this.setState({
                                                            companyKanaName: e.currentTarget.value
                                                        });
                                                    }}
                                                    value={this.state.companyKanaName}
                                                />
                                                <br/>
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <label htmlFor="companyZip" className="grey-text">
                                                        郵便番号
                                                    </label>
                                                    &nbsp;
                                                    <span className={'cart-require'}
                                                          style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    flexDirection: "row"
                                                }}>
                                                    <input
                                                        type="text"
                                                        id="companyZip"
                                                        className="form-control"
                                                        name="companyZip"
                                                        placeholder={'例）123-4567（ハイフン付き7桁）'}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                companyZip: e.currentTarget.value
                                                            });
                                                        }}
                                                        value={this.state.companyZip}
                                                    />
                                                    <MDBBtn color="white" disabled={this.state.companyZip.length === 8 ? false : true} style={{
                                                        backgroundColor: '#FFFFFF',
                                                        color: '#2D486A',
                                                        height: 38, width: 120,
                                                        border: '1px solid #2D486A',
                                                        alignItems: 'center',
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 5,
                                                        paddingRight: 5
                                                    }}
                                                            onClick={this.handleZipChange}>住所を入れる</MDBBtn>
                                                </div>
                                                <br/>
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <label htmlFor="companyAddress" className="grey-text">
                                                        住所
                                                    </label>
                                                    &nbsp;
                                                    <span className={'cart-require'}
                                                          style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    id="companyAddress"
                                                    className="form-control"
                                                    name="companyAddress"
                                                    onChange={(e) => {
                                                        this.setState({
                                                            companyAddress: e.currentTarget.value
                                                        });
                                                    }}
                                                    value={this.state.companyAddress}
                                                />
                                                <br/>
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <label htmlFor="companyTel" className="grey-text">
                                                        TEL
                                                    </label>
                                                    &nbsp;
                                                    <span className={'cart-require'}
                                                          style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    id="companyTel"
                                                    className="form-control"
                                                    name="companyTel"
                                                    onChange={(e) => {
                                                        this.setState({
                                                            companyTel: e.currentTarget.value
                                                        });
                                                    }}
                                                    value={this.state.companyTel}
                                                />
                                                <br/>
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <label htmlFor="companyFax" className="grey-text">
                                                        FAX
                                                    </label>
                                                    &nbsp;
                                                    <span className={'cart-require'}
                                                          style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    id="companyFax"
                                                    className="form-control"
                                                    name="companyFax"
                                                    onChange={(e) => {
                                                        this.setState({
                                                            companyFax: e.currentTarget.value
                                                        });
                                                    }}
                                                    value={this.state.companyFax}
                                                />
                                                <br/>
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <label htmlFor="companyCorpNo" className="grey-text">
                                                        法人番号
                                                    </label>
                                                    &nbsp;
                                                    <span className={'cart-require'}
                                                          style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    id="companyCorpNo"
                                                    className="form-control"
                                                    name="companyCorpNo"
                                                    placeholder={'13桁（ハイフン不要）'}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            companyCorpNo: e.currentTarget.value
                                                        });
                                                    }}
                                                    value={this.state.companyCorpNo}
                                                />
                                            </div>

                                        </div>
                                    }
                                    <div style={{
                                        height: 30, justifyContent: 'flex-start', padding: 5,
                                        alignItems: "center", backgroundColor: '#2E75B6', color: 'white'
                                    }}>事業所情報
                                    </div>
                                    <div style={{
                                        border: '1px solid #B9B9B9',
                                        padding: 10,
                                        marginBottom: 20,
                                        marginTop: 10
                                    }}>
                                        <div className="form-check">
                                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                <MDBBtn color="white" style={{
                                                    backgroundColor: '#FFFFFF',
                                                    color: '#2D486A',
                                                    height: 26,
                                                    border: '1px solid #2D486A',
                                                    alignItems: 'center',
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 5,
                                                    paddingRight: 5
                                                }}
                                                        onClick={() => {
                                                            if (this.state.isNewCompany) {
                                                                this.state.companyFax && this.setState({fax: this.state.companyFax});
                                                                this.state.companyTel && this.setState({tel: this.state.companyTel});
                                                                this.state.companyAddress && this.setState({address: this.state.companyAddress});
                                                                this.state.companyZip && this.setState({zipcode: this.state.companyZip});
                                                            } else if (this.state.isSelectedCompany && this.state.company) {
                                                                let data = this.state.companyList.filter(v => v.id === this.state.company)[0];
                                                                data['FAX'] !== undefined && this.setState({fax: data['FAX']});
                                                                data['TEL'] !== undefined && this.setState({tel: data['TEL']});
                                                                data['address'] !== undefined && this.setState({address: data['address']});
                                                                data['zipcode'] !== undefined && this.setState({zipcode: data['zipcode']});
                                                            }

                                                        }}>会社情報をコピー</MDBBtn>
                                            </div>
                                            <div>
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <label htmlFor="closingDate" className="grey-text">
                                                        U種別
                                                    </label>
                                                    &nbsp;
                                                    <span className={'cart-require'}
                                                          style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                </div>
                                                <Select
                                                    disabled={this.props.mode === 'edit' ? true : false}
                                                    value={this.state.mode}
                                                    style={{width: '100%'}}
                                                    placeholder="選択してください"
                                                    //defaultValue={this.state.company}
                                                    onChange={(e) => {
                                                        this.setState({mode: e,selectedBuyerOrg: null,selectedSellerOrg: null});
                                                    }}
                                                    options={this.state.modeList}
                                                />
                                            </div>
                                            <br/>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <label htmlFor="name" className="grey-text">
                                                    事業所名
                                                </label>
                                                &nbsp;
                                                <span className={'cart-require'}
                                                      style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                            </div>
                                            <input
                                                type="text"
                                                id="name"
                                                className="form-control"
                                                name="name"
                                                onChange={(e) => {
                                                    this.setState({
                                                        name: e.currentTarget.value
                                                    });
                                                }}
                                                value={this.state.name}
                                            />
                                            <br/>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <label htmlFor="kana" className="grey-text">
                                                    事業所名かな
                                                </label>
                                                &nbsp;
                                                <span className={'cart-require'}
                                                      style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                            </div>
                                            <input
                                                type="text"
                                                id="kana"
                                                className="form-control"
                                                name="kana"
                                                onChange={(e) => {
                                                    this.setState({
                                                        kana: e.currentTarget.value
                                                    });
                                                }}
                                                value={this.state.kana}
                                            />
                                            <br/>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <label htmlFor="zipcode" className="grey-text">
                                                    郵便番号
                                                </label>
                                                &nbsp;
                                                <span className={'cart-require'}
                                                      style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                            </div>
                                            <input
                                                type="text"
                                                id="zipcode"
                                                className="form-control"
                                                name="zipcode"
                                                onChange={(e) => {
                                                    this.setState({
                                                        zipcode: e.currentTarget.value
                                                    });
                                                }}
                                                value={this.state.zipcode}
                                            />
                                            <br/>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <label htmlFor="address" className="grey-text">
                                                    住所
                                                </label>
                                                &nbsp;
                                                <span className={'cart-require'}
                                                      style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                            </div>
                                            <input
                                                type="text"
                                                id="address"
                                                className="form-control"
                                                name="address"
                                                onChange={(e) => {
                                                    this.setState({
                                                        address: e.currentTarget.value
                                                    });
                                                }}
                                                value={this.state.address}
                                            />
                                            <br/>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <label htmlFor="tel" className="grey-text">
                                                    TEL
                                                </label>
                                                &nbsp;
                                                <span className={'cart-require'}
                                                      style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                            </div>
                                            <input
                                                type="text"
                                                id="tel"
                                                className="form-control"
                                                name="tel"
                                                onChange={(e) => {
                                                    this.setState({
                                                        tel: e.currentTarget.value
                                                    });
                                                }}
                                                value={this.state.tel}
                                            />
                                            <br/>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <label htmlFor="fax" className="grey-text">
                                                    FAX
                                                </label>
                                                &nbsp;
                                                <span className={'cart-require'}
                                                      style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                            </div>
                                            <input
                                                type="fax"
                                                id="fax"
                                                className="form-control"
                                                name="fax"
                                                onChange={(e) => {
                                                    this.setState({
                                                        fax: e.currentTarget.value
                                                    });
                                                }}
                                                value={this.state.fax}
                                            />
                                            <br/>
                                            {
                                                this.state.mode === 'buyer' &&
                                                <div>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <label htmlFor="seller" className="grey-text">
                                                            相手先事業所選択
                                                        </label>
                                                        &nbsp;
                                                        <span className={'cart-require'}
                                                              style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                    </div>
                                                    <Select
                                                        showSearch
                                                        value={this.state.seller}
                                                        optionFilterProp="label"
                                                        filterSort={(optionA, optionB) =>
                                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                        }
                                                        style={{width: '100%'}}
                                                        placeholder="選択してください"
                                                        onChange={(e) => {
                                                            this.setState({seller: e})
                                                        }}
                                                        options={this.state.sellerList.map((data) => ({
                                                            value: data.id,
                                                            label: data.company_name + ' ' + data.name
                                                        }))}
                                                    />
                                                </div>
                                            }
                                            {
                                                this.state.mode === 'seller' &&
                                                <div>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <label htmlFor="seller" className="grey-text">
                                                            購入U
                                                        </label>
                                                        &nbsp;
                                                        <span className={'cart-require'}
                                                              style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                    </div>
                                                    <Select
                                                        mode="multiple"
                                                        optionFilterProp="label"
                                                        filterSort={(optionA, optionB) =>
                                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                        }
                                                        style={{width: '100%'}}
                                                        placeholder="選択してください"
                                                        value={this.state.selectedBuyerOrg}
                                                        onChange={(e) => {
                                                            this.setState({selectedBuyerOrg: e})
                                                        }}
                                                        options={this.state.buyerList}
                                                    />
                                                </div>

                                            }
                                            {
                                                this.state.mode === 'maker' &&
                                                <div>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <label htmlFor="seller" className="grey-text">
                                                            購入U
                                                        </label>
                                                        &nbsp;
                                                        <span className={'cart-require'}
                                                              style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                    </div>
                                                    <Select
                                                        mode="multiple"
                                                        optionFilterProp="label"
                                                        filterSort={(optionA, optionB) =>
                                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                        }
                                                        style={{width: '100%'}}
                                                        placeholder="選択してください"
                                                        value={this.state.selectedBuyerOrg}
                                                        onChange={(e) => {
                                                            this.setState({selectedBuyerOrg: e})
                                                        }}
                                                        options={this.state.sellerList.map((data) => ({
                                                            value: data.id,
                                                            label: data.company_name + ' ' + data.name
                                                        }))}
                                                    />
                                                </div>

                                            }
                                            {
                                                this.state.mode === 'seller' &&
                                                <div>
                                                    <br/>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <label htmlFor="seller" className="grey-text">
                                                            メーカーU
                                                        </label>
                                                        &nbsp;
                                                        <span className={'cart-require'}
                                                              style={{marginBottom: '0.5rem', marginTop: 0}}>必須</span>
                                                    </div>
                                                    <Select
                                                        mode="multiple"
                                                        showSearch
                                                        value={this.state.selectedSellerOrg}
                                                        optionFilterProp="label"
                                                        filterSort={(optionA, optionB) =>
                                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                        }
                                                        style={{width: '100%'}}
                                                        placeholder="選択してください"
                                                        onChange={(e) => {
                                                            this.setState({selectedSellerOrg: e})
                                                        }}
                                                        options={this.state.makerList.map((data) => ({
                                                            value: data.id,
                                                            label: data.company_name + ' ' + data.name
                                                        }))}
                                                    />
                                                </div>
                                            }
                                            <br/>
                                            <div style={{color: '#212529', fontWeight: 'bold'}}>
                                                支払い条件
                                            </div>
                                            <br/>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <label htmlFor="paymentMethod" className="grey-text">
                                                    支払方法
                                                </label>
                                                &nbsp;
                                                <span className={'cart-require-any'}
                                                      style={{marginBottom: '0.5rem', marginTop: 0}}>任意</span>
                                            </div>
                                            <input
                                                type="paymentMethod"
                                                id="paymentMethod"
                                                className="form-control"
                                                name="paymentMethod"
                                                onChange={(e) => {
                                                    this.setState({
                                                        paymentMethod: e.currentTarget.value
                                                    });
                                                }}
                                                value={this.state.paymentMethod}
                                            />
                                            <br/>

                                            <div style={{
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                display: 'flex', alignItems: 'center'
                                            }}>
                                                <div style={{
                                                    flexDirection: 'row',
                                                    justifyContent: 'flex-start',
                                                    display: 'flex', alignItems: 'center'
                                                }}>
                                                    <div>
                                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                                            <label htmlFor="paymentCheck" className="grey-text">
                                                                支払日
                                                            </label>
                                                            &nbsp;
                                                            <span className={'cart-require-any'} style={{
                                                                marginBottom: '0.5rem',
                                                                marginTop: 0
                                                            }}>任意</span>
                                                        </div>
                                                        <Select
                                                            value={this.state.paymentCheck}
                                                            style={{width: '100px'}}
                                                            placeholder="選択してください"
                                                            allowClear={true}
                                                            onChange={(e) => {
                                                                console.log('ererer', e);
                                                                this.setState({paymentCheck: e})
                                                            }}
                                                            options={this.state.paymentCheckList}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                                            <label htmlFor="paymentDate" className="grey-text">
                                                                &nbsp;
                                                            </label>
                                                            &nbsp;
                                                            <span className={'cart-require-any'} style={{
                                                                marginBottom: '0.5rem',
                                                                marginTop: 0
                                                            }}>任意</span>
                                                        </div>
                                                        <Select
                                                            value={this.state.paymentDate}
                                                            style={{width: '80px'}}
                                                            placeholder="選択してください"
                                                            allowClear={true}
                                                            //defaultValue={this.state.company}
                                                            onChange={(e) => {
                                                                this.setState({paymentDate: e})
                                                            }}
                                                            options={this.state.days}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <label htmlFor="closingDate" className="grey-text">
                                                            締日
                                                        </label>
                                                        &nbsp;
                                                        <span className={'cart-require-any'}
                                                              style={{marginBottom: '0.5rem', marginTop: 0}}>任意</span>
                                                    </div>
                                                    <Select
                                                        value={this.state.closingDate}
                                                        style={{width: '80px'}}
                                                        placeholder="選択してください"
                                                        allowClear={true}
                                                        onChange={(e) => {
                                                            this.setState({closingDate: e})
                                                        }}
                                                        options={this.state.closingDateList}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </MDBCol>

                        </MDBRow>
                        <div style={{flexDirection: 'row', justifyContent: 'center', display: 'flex'}}>
                            <MDBBtn color="secondary"
                                    onClick={() => this.props.cProps.history.push('/orgList')}>キャンセル</MDBBtn>
                            <MDBBtn
                                color="default"
                                type="submit"
                                disabled={isDisabled}
                                onClick={this.onSubmit}
                            >登録</MDBBtn>
                        </div>
                    </MDBContainer>
                }
            </>
        )
    }

}

export default CreateNewBuyerOrg;